import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ltlSourceCity, palletValidation } from 'global/Models/addressModel';

type initialStateType = {
  ltlSourceCities: ltlSourceCity[] | undefined;
  ltlDestinationCities: ltlSourceCity[] | undefined;
  palletValidation: palletValidation | undefined;
};

const initialState: initialStateType = { ltlSourceCities: undefined, ltlDestinationCities: undefined, palletValidation: undefined };

export const ltlSlice = createSlice({
  name: 'ltl',
  initialState,
  reducers: {
    setLTLDestinationCities: (state, { payload }: PayloadAction<ltlSourceCity[]>) => {
      state.ltlDestinationCities = payload;
    },
    setLTLSourceCities: (state, { payload }: PayloadAction<ltlSourceCity[]>) => {
      state.ltlSourceCities = payload;
    },
    setPalletValidation: (state, { payload }: PayloadAction<palletValidation>) => {
      state.palletValidation = payload;
    },
  },
});

export const { setLTLSourceCities, setLTLDestinationCities, setPalletValidation } = ltlSlice.actions;

export default ltlSlice.reducer;
